import script from "./tabls1.vue?vue&type=script&lang=ts&setup=true"
export * from "./tabls1.vue?vue&type=script&lang=ts&setup=true"

import "./tabls1.vue?vue&type=style&index=0&id=ad9ae19a&lang=css"

const __exports__ = script;

export default __exports__